module.exports = __webpack_public_path__ + "img/17868_L.dd46b434.png";